<template>
  <div class="complete-info">
    <div class="checkFail" v-if="authorForm.checkStatus === 2">审核失败：{{ authorForm.checkReason }}</div>
    <div v-if="authorForm.authorType == 1">
      <el-form ref="authorForm" :model="authorForm" :rules="authorFormRules" size="small" label-width="120px">
        <el-form-item label="身份证姓名" prop="realName">
          <el-input v-model="authorForm.realName" maxlength="30" placeholder="请输入身份证姓名"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="idType">
          <el-select v-model="authorForm.idType">
            <el-option label="身份证" value="1"></el-option>
            <el-option label="护照" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="idNum">
          <el-input v-model="authorForm.idNum" maxlength="30" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item label="支付宝收款人" prop="alipayPayee">
          <el-input v-model="authorForm.alipayPayee" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="支付宝账户" prop="alipayAccount">
          <el-input v-model="authorForm.alipayAccount" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="证件正面" prop="idFrontPic">
          <MyUpload info="仅支持jpg、png, 小于20M" accept="image/png,image/jpeg" :imgKey.sync="authorForm.idFrontPic" :url="authorForm.idFrontPicUrl" />
        </el-form-item>
        <el-form-item label="证件反面" prop="idBackPic">
          <MyUpload info="仅支持jpg、png, 小于20M" accept="image/png,image/jpeg" :imgKey.sync="authorForm.idBackPic" :url="authorForm.idBackPicUrl" />
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="实名认证状态：" prop="landlineTel">
          <div style="display: flex">
            {{ aliVerityStatusObj[authorForm.aliVerityStatus] || '待认证' }}
            <el-button :loading="aliVerityLoading" v-if="authorForm.aliVerityStatus != 1" type="primary" style="margin-left: 10px;" @click="aliVerity">去认证</el-button>
          </div>
          <div v-if="authorForm.aliVerityStatus == 2" style="margin-bottom: 0" class="checkFail">
            {{ authorForm.verityReason }}
          </div>
        </el-form-item>
        <!-- <el-form-item label="营业执照" prop="businessLicPicUrl">
        <MyUpload info="仅支持jpg、png, 小于20M" :imgKey.sync="authorForm.businessLicPic" :url="authorForm.businessLicPicUrl" />
      </el-form-item> -->
      </el-form>
    </div>
    <div v-if="authorForm.authorType == 2"  class="company">
      <el-form ref="authorForm" :rules="companyFormRules" :model="authorForm" size="small" label-width="130px">
        <el-form-item label="申请人" prop="realName">
          <el-input readonly v-model="authorForm.realName" maxlength="30" placeholder="请输入生产者"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idNum">
          <el-input readonly v-model="authorForm.idNum" maxlength="18" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="公司营业执照号" prop="businessLicNo">
          <el-input readonly v-model="authorForm.businessLicNo" maxlength="30" placeholder="请输入公司营业执照号"></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="companyAddr">
          <el-input readonly v-model="authorForm.companyAddr" maxlength="30" placeholder="请输入公司地址"></el-input>
        </el-form-item>
        <el-form-item label="固定电话" prop="landlineTel">
          <el-input readonly v-model="authorForm.landlineTel" maxlength="30" placeholder="请输入公司固定电话"></el-input>
        </el-form-item>
        <el-form-item label="支付宝收款人" prop="alipayPayee">
          <el-input v-model="authorForm.alipayPayee" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="支付宝账户" prop="alipayAccount">
          <el-input v-model="authorForm.alipayAccount" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证正面" prop="idFrontPic">
          <MyUpload info="仅支持jpg、png, 小于20M" :imgKey.sync="authorForm.idFrontPic" :url="authorForm.idFrontPicUrl" />
        </el-form-item>
        <el-form-item label="法人身份证反面" prop="idBackPic">
          <MyUpload info="仅支持jpg、png, 小于20M" :imgKey.sync="authorForm.idBackPic" :url="authorForm.idBackPicUrl" />
        </el-form-item>
        <el-form-item label="营业执照照片" prop="businessLicPic">
          <MyUpload info="仅支持jpg、png, 小于20M" :imgKey.sync="authorForm.businessLicPic" :url="authorForm.businessLicPicUrl" />
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button style="margin-left: 120px;" @click="$router.back()">取消</el-button>
      <el-button type="primary" @click="confirm">更新资料</el-button>
    </div>
  </div>
</template>

<script>
import API from '../lib/API'
import MyUpload from '../components/common/MyUpload'
export default {
  name: 'CertificateInfo',
  components: {
    MyUpload
  },
  data() {
    return {
      authorForm: {
        realName: '',
        idType: 1,
        idNum: '',
        alipayPayee: '',
        alipayAccount: '',
        idFrontPic: '',
        idFrontPicUrl: '',
        idBackPic: '',
        idBackPicUrl: '',
        businessLicNo: '',
        companyAddr: '',
        landlineTel: '',
        businessLicPic: '',
        aliVerityStatus: 0,
        verityReason: '',
        checkStatus: 0,
        checkReason: '',
        authorType: 0,
      },
      aliVerityLoading: false,
      aliVerityStatusObj: {
        0: '待认证',
        1: '认证成功',
        2: '认证失败'
      },
      authorFormRules: {
        idFrontPic: [{ required: true, message: '请上传证件正面' }],
        alipayPayee: [{ required: true, message: '请输入支付宝收款人' }],
        idNum: [{ required: true, message: '请输入支付宝收款人' }],
        alipayAccount: [{ required: true, message: '请输入支付宝账号' }],
        idBackPic: [{ required: true, message: '请上传证件反面' }]
      },
      companyFormRules: {
        idFrontPic: [{ required: true, message: '请上传法人证件正面' }], 
        idBackPic: [{ required: true, message: '请上传法人证件反面' }], 
        businessLicPic: [{ required: true, message: '请上传营业执照' }], 
      }
    }
  },
  created() {
    this.authorId = localStorage.getItem('authorId')
    this.getInfo()
    this.editVerity()
  },
  methods: {
    editVerity() {
      let { auth_code, cert_verify_id } = this.$route.query || {}
      if (!auth_code) return
      new API(this).POST({
        url: `/author/aliCertVerifyCall?auth_code=${auth_code}&cert_verify_id=${cert_verify_id}`,
        cb: res => {
          if (res == 1) {
            this.$message.success('认证成功')
            localStorage.setItem('aliVerityStatus', 1)
          } else {
            this.$message.error('认证失败')
            localStorage.setItem('aliVerityStatus', 2)
          }
          this.$router.replace('/certificateInfo')
          this.getInfo()
        }
      })
    },
    aliVerity() {
      // this.aliVerityLoading = true
      new API(this).POST({
        url: `/author/getAliCertVerifyUrl`,
        params: {
          authorId: this.authorId,
          url: window.location.href
        },
        cb: res => {
          this.aliVerityLoading = false
          window.location.href = res
        },
        errCb: err => {
          this.aliVerityLoading = false
        }
      })
    },
    confirm() {
      this.$refs.authorForm
        .validate()
        .then(res => {
          new API(this).POST({
            url: '/author/updateAuthorCertInfo',
            params: this.authorForm,
            cb: res => {
              this.$message.success('更新成功')
              this.getInfo()
            }
          })
        })
        .catch(err => {
          console.log('校验不通过')
        })
    },
    getInfo() {
      new API(this).POST({
        url: `/author/getCertDetail?authorId=${this.authorId}`,
        cb: res => {
          Object.assign(this.authorForm, res)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.complete-info {
  width: 400px;
  margin: 0 auto;
}
.checkFail {
  color: #f56c6c;
  font-weight: bold;
  margin-bottom: 20px;
}
.btn-group {
  display: flex;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/CertificateInfo.vue